/* ================================================================
   eliviro — theme.js
   Vanilla JS · header, cart drawer (AJAX), reveals, PDP, sliders
   ================================================================ */
(function(){
  'use strict';
  const $  = (s,c=document)=>c.querySelector(s);
  const $$ = (s,c=document)=>[...c.querySelectorAll(s)];
  const money = c => (window.Shopify?.formatMoney)
      ? Shopify.formatMoney(c, window.__moneyFormat || '{{amount}}')
      : new Intl.NumberFormat('es-ES',{style:'currency',currency:window.__currency||'EUR'}).format(c/100);

  /* ---------- Header: transparent → solid on scroll ---------- */
  const header = $('#site-header');
  if(header){
    const transparent = header.classList.contains('is-transparent');
    const onScroll = ()=>{
      const solid = window.scrollY > 40 || !transparent;
      header.classList.toggle('is-solid', solid);
      header.classList.toggle('is-transparent', transparent && !solid);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* ---------- Mobile drawer ---------- */
  const mDrawer = $('#mobile-drawer'), overlay = $('#overlay');
  $$('[data-mobile-open]').forEach(b=>b.addEventListener('click',()=>{mDrawer?.classList.add('is-open');overlay?.classList.add('is-open');}));
  $$('[data-mobile-close]').forEach(b=>b.addEventListener('click',closeAll));

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((es)=>{
    es.forEach(e=>{ if(e.isIntersecting){e.target.classList.add('is-in'); io.unobserve(e.target);} });
  },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
  $$('[data-reveal]').forEach((el,i)=>{ el.style.transitionDelay = (i%4*70)+'ms'; io.observe(el); });

  /* ---------- Accordions (FAQ + PDP) ---------- */
  $$('[data-acc]').forEach(acc=>{
    acc.addEventListener('click',()=>{
      const item = acc.closest('.acc__item');
      const body = item.querySelector('.acc__a');
      const open = item.classList.toggle('is-open');
      body.style.maxHeight = open ? body.scrollHeight+'px' : 0;
    });
  });

  /* ---------- Sliders ---------- */
  $$('[data-slider]').forEach(wrap=>{
    const track = $('[data-slider-track]',wrap);
    const prev = $('[data-slider-prev]',wrap), next = $('[data-slider-next]',wrap);
    const step = ()=> Math.min(track.clientWidth*.85, 340);
    prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  });

  /* ---------- Wishlist (localStorage) ---------- */
  const WL_KEY='eliviro_wishlist';
  const getWL = ()=>{try{return JSON.parse(localStorage.getItem(WL_KEY))||[]}catch{return[]}};
  const setWL = a=>localStorage.setItem(WL_KEY,JSON.stringify(a));
  const syncWL = ()=>{ const wl=getWL();
    $$('[data-wish]').forEach(b=>b.classList.toggle('is-active', wl.includes(b.dataset.wish)));
    const c=$('#wishlist-count'); if(c){ c.textContent=wl.length; c.classList.toggle('hide',!wl.length);} };
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-wish]'); if(!b) return;
    e.preventDefault();
    let wl=getWL(); const id=b.dataset.wish;
    wl = wl.includes(id) ? wl.filter(x=>x!==id) : [...wl,id];
    setWL(wl); syncWL();
  });
  syncWL();

  /* ================= CART DRAWER (AJAX) ================= */
  const drawer = $('#cart-drawer');
  const THRESHOLD = window.__freeShipThreshold || 0; // cents

  function closeAll(){ drawer?.classList.remove('is-open'); mDrawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow=''; }
  function openCart(){ drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow='hidden'; }
  overlay?.addEventListener('click',closeAll);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeAll(); });
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openCart();fetchCart();}));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click',closeAll));

  async function fetchCart(){
    try{ const r = await fetch('/cart.js'); renderCart(await r.json()); }catch(e){}
  }
  function updateBubble(count){
    $$('[data-cart-count]').forEach(el=>{ el.textContent=count; el.classList.toggle('hide',!count); });
  }
  function renderCart(cart){
    updateBubble(cart.item_count);
    const body = $('#cart-body'); if(!body) return;
    // free-shipping progress
    const bar = $('#ship-fill'), msg = $('#ship-msg');
    if(bar && THRESHOLD>0){
      const pct = Math.min(100, cart.total_price/THRESHOLD*100);
      bar.style.width = pct+'%';
      const left = THRESHOLD - cart.total_price;
      msg.innerHTML = left>0
        ? `Te faltan <b>${money(left)}</b> para el <b>envío gratis</b>`
        : `🎉 ¡Tienes <b>envío gratis</b>!`;
    }
    if(!cart.items.length){
      body.innerHTML = `<div class="cart-empty">
        <p class="h2 u-serif">Tu cesta está vacía</p>
        <p class="muted">Descubre nuestras últimas novedades.</p>
        <a href="/collections/all" class="btn btn--primary" data-cart-close>Ir a la tienda</a></div>`;
      $('#cart-foot')?.classList.add('hide');
      body.querySelector('[data-cart-close]')?.addEventListener('click',closeAll);
      return;
    }
    $('#cart-foot')?.classList.remove('hide');
    body.innerHTML = cart.items.map(it=>`
      <div class="cart-line" data-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2') : ''}" alt="${it.product_title}" loading="lazy"></a>
        <div>
          <div class="cart-line__t">${it.product_title}</div>
          <div class="cart-line__v">${it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : ''}</div>
          <div class="qty" style="margin-top:.5rem">
            <button data-qty="-1" aria-label="Quitar uno">−</button>
            <input value="${it.quantity}" readonly>
            <button data-qty="1" aria-label="Añadir uno">+</button>
          </div>
          <button class="cart-line__rm" data-remove>Eliminar</button>
        </div>
        <div class="cart-line__t">${money(it.final_line_price)}</div>
      </div>`).join('');
    $('#cart-subtotal').textContent = money(cart.total_price);

    body.querySelectorAll('.cart-line').forEach(line=>{
      const key=line.dataset.key;
      line.querySelectorAll('[data-qty]').forEach(btn=>btn.addEventListener('click',()=>{
        const cur=+line.querySelector('input').value;
        changeItem(key, Math.max(0,cur+ +btn.dataset.qty));
      }));
      line.querySelector('[data-remove]').addEventListener('click',()=>changeItem(key,0));
    });
  }
  async function changeItem(id,qty){
    try{
      const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id,quantity:qty})});
      renderCart(await r.json());
    }catch(e){}
  }

  /* Add to cart — intercept product forms + quick-add */
  document.addEventListener('submit', async e=>{
    const form = e.target.closest('form[action*="/cart/add"], form[data-atc]');
    if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.textContent;
    if(btn){ btn.disabled=true; btn.textContent='Añadiendo…'; }
    try{
      const r = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if(!r.ok){ throw await r.json(); }
      await fetchCart(); openCart();
    }catch(err){
      if(btn){ btn.textContent = err?.description || 'No disponible'; setTimeout(()=>btn.textContent=label,1600); }
    }finally{
      if(btn){ btn.disabled=false; setTimeout(()=>{ if(btn.textContent==='Añadiendo…') btn.textContent=label; },50);
        setTimeout(()=>btn.textContent=label,1200); }
    }
  });

  /* ================= PDP: variants + gallery + sticky ================= */
  const pdp = $('#product-form');
  if(pdp){
    const data = JSON.parse($('#product-json').textContent);
    const priceEl=$('#pdp-price'), stockEl=$('#pdp-stock'), atcBtn=$('#atc-btn'), idInput=$('#variant-id');
    const stickyBtn=$('#sticky-atc-price');

    function currentVariant(){
      const chosen = $$('.opt input:checked',pdp).map(i=>i.value);
      return data.variants.find(v=>{
        return chosen.every(val=>v.options.includes(val));
      }) || data.variants.find(v=>v.available);
    }
    function updateVariant(){
      const v=currentVariant(); if(!v) return;
      idInput.value=v.id;
      priceEl.innerHTML = v.compare_at_price>v.price
        ? `<span class="price--sale">${money(v.price)}</span> <span class="price--compare">${money(v.compare_at_price)}</span>`
        : money(v.price);
      if(stickyBtn) stickyBtn.textContent = money(v.price);
      const avail=v.available;
      atcBtn.disabled=!avail;
      atcBtn.textContent = avail ? 'Añadir a la cesta' : 'Agotado';
      if(stockEl){
        if(!avail){ stockEl.innerHTML=`<span class="stock-dot" style="background:var(--stone)"></span> Agotado`; }
        else if(v.inventory_management && v.inventory_quantity>0 && v.inventory_quantity<=6){
          stockEl.innerHTML=`<span class="stock-dot stock-dot--low"></span> Últimas ${v.inventory_quantity} unidades`;
          stockEl.style.color='var(--accent)';
        } else { stockEl.innerHTML=`<span class="stock-dot"></span> En stock · listo para enviar`; stockEl.style.color='var(--ok)'; }
      }
      // disable impossible sizes given chosen colour
      history.replaceState({}, '', `?variant=${v.id}`);
    }
    $$('.opt input',pdp).forEach(i=>i.addEventListener('change',updateVariant));
    updateVariant();

    // gallery zoom (lightbox-lite)
    $$('[data-zoom]',pdp.closest('.pdp')||document).forEach(fig=>{
      fig.addEventListener('click',()=>{
        const src=fig.querySelector('img')?.src; if(!src) return;
        const lb=document.createElement('div'); lb.className='overlay is-open';
        lb.style.cssText='display:grid;place-content:center;z-index:300;cursor:zoom-out';
        lb.innerHTML=`<img src="${src}" style="max-width:92vw;max-height:92vh;border-radius:12px">`;
        lb.addEventListener('click',()=>lb.remove()); document.body.appendChild(lb);
      });
    });

    // sticky ATC on mobile
    const sticky=$('#sticky-atc');
    if(sticky){
      const io2=new IntersectionObserver(es=>{
        sticky.classList.toggle('is-visible', !es[0].isIntersecting && es[0].boundingClientRect.top<0);
      },{threshold:0});
      io2.observe(pdp);
      $('#sticky-atc-btn')?.addEventListener('click',()=>atcBtn.click());
    }
  }

  /* ---------- Recently viewed ---------- */
  const RV_KEY='eliviro_recent';
  const handleEl=$('#product-handle');
  if(handleEl){
    let rv=[]; try{rv=JSON.parse(localStorage.getItem(RV_KEY))||[]}catch{}
    rv=[handleEl.value,...rv.filter(h=>h!==handleEl.value)].slice(0,8);
    localStorage.setItem(RV_KEY,JSON.stringify(rv));
  }

  /* ---------- Collection: mobile filters toggle ---------- */
  $('[data-filter-toggle]')?.addEventListener('click',()=>$('#filters')?.classList.toggle('is-open'));

  // expose money format from theme
  window.Eliviro = { openCart, fetchCart };
})();
